import getSymbolFromCurrency from "currency-symbol-map";
import Button from "src/components/Button";
import DialogModal from "src/components/Dialog";
import { InawoGreenLuxeIcon } from "src/components/Icons";
import { formatMoney } from "src/helper/functions";
import styles from "./luxeVideoUpgrade.module.scss";

interface Props {
  opened: boolean;
  currency: string | undefined;
  discountedCost: number | undefined;
  setIsLuxeFeaturesOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsLuxeVideoUpgradeOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenPaymentFlow: React.Dispatch<React.SetStateAction<boolean>>;
}

const LuxeVideoUpgrade = ({
  opened,
  currency,
  discountedCost,
  setIsLuxeFeaturesOpen,
  setIsLuxeVideoUpgradeOpen,
  setOpenPaymentFlow,
}: Props) => {
  // Show loading state only when fetching and no cached data is available
  // if (loading && !data?.describeLuxe) {
  //   return <InnerLoading />;
  // }

  return (
    <>
      <DialogModal open={opened} onOpenChange={setIsLuxeVideoUpgradeOpen}>
        <div className={styles["addPictures"]}>
          <div className={styles["addPictures-heading"]}>
            <h4>{"Add Photo/Video"}</h4>
          </div>

          <div className={styles["addPictures-form"]}>
            <div className={styles["addPictures-form-container"]}>
              <div className="my-4 w-full text-center">
                <h3 className="text-xl font-semibold">Upload is too large</h3>
              </div>
              <div className={`${styles["addPictures-image-box2"]} mb-12`}>
                <div className="relative">
                  <img
                    src="luxe-upgrade-image.png"
                    alt="Upgrade to Luxe"
                    className="h-[90px] w-[90px]"
                  />
                  <img
                    src="ellipse.png"
                    alt="Upgrade to Luxe"
                    className="absolute -bottom-[25px] -right-[35px]"
                  />
                  <img
                    src="white-play.png"
                    className="absolute -bottom-[8px] -right-[18px] h-[35px] w-[30px]"
                    alt="Upgrade to Luxe"
                  />
                </div>
              </div>

              <div className="mb-[22px] flex w-full items-center justify-center">
                <h3 className="flex items-center text-[15px] font-medium uppercase tracking-[2px] text-[#A9A9A9] lg:tracking-[4.5px]">
                  Upgrade to
                  <span className="">
                    <InawoGreenLuxeIcon />
                  </span>
                </h3>
              </div>

              <div className="flex w-full items-center justify-center text-center leading-6 text-[#707070]">
                <span className="w-[300px]">
                  Uploading of videos above{" "}
                  <span className="font-bold text-[#000000]">15 seconds</span>{" "}
                  are only allowed with the Luxe package
                </span>
              </div>

              <>
                <div
                  className={`${styles["addPictures-button-container"]} text-sm`}
                >
                  <div className={styles["addPictures-button"]}>
                    <Button
                      type="button"
                      label="Add Photos/Videos"
                      design="secondary"
                      onClick={() => {
                        setIsLuxeVideoUpgradeOpen(false);
                        setIsLuxeFeaturesOpen(true);
                      }}
                    >
                      Learn more about Luxe
                    </Button>
                  </div>
                  <div className={styles["addPictures-button"]}>
                    <Button
                      type="button"
                      label="pay for luxe"
                      design="secondary"
                      onClick={() => {
                        setIsLuxeVideoUpgradeOpen(false);
                        setOpenPaymentFlow(true);
                      }}
                      // loader={addMediaLoading || addAlbumLoading || submitting}
                    >
                      Pay {getSymbolFromCurrency(currency ?? "")}
                      {formatMoney(discountedCost ?? 0)} for Luxe
                    </Button>
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </DialogModal>
    </>
  );
};

export default LuxeVideoUpgrade;
